import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import TripleHelixPiercingImage from '../../Assets/Piercing Services/triple helix piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function TripleHelixPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Triple Helix Piercing UAE | 300 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Triple Helix Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Triple Helix Piercing 300 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={TripleHelixPiercingImage} alt="Triple Helix Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Triple Helix Piercing</h3>

          <p>
            Make a bold and stylish statement with our professional triple helix piercing services in the UAE, available at an affordable price of 300 AED. Triple helix piercing is a striking and modern ear piercing style that features three cartilage piercings placed along the upper outer edge of the ear, creating a layered and eye-catching look. Perfect for individuals who want to stand out and express their unique personality, this piercing adds depth, dimension, and a fashionable edge to your overall appearance. Whether you prefer minimal studs for a clean aesthetic or a mix of hoops and statement jewelry, our expert specialists ensure precise alignment and placement for a perfectly balanced result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our highest priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each triple helix piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Since triple helix piercing involves multiple cartilage points, our experienced specialists use advanced techniques to reduce discomfort and make the procedure as quick and efficient as possible.
          </p>

          <p>
            Triple helix piercing is ideal for those who want a bold, layered ear design that stands out from traditional piercings. It pairs beautifully with other ear piercings such as lobe, tragus, conch, or industrial, allowing you to create a fully curated and personalized ear style. Our team provides personalized consultation to understand your preferences and recommend the best spacing, placement, and jewelry options that suit your ear structure and desired look.
          </p>

          <p>
            The procedure is typically completed within a short time, even with three piercings, making it convenient for clients with busy schedules. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process. Our goal is to deliver a safe, comfortable, and stylish experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that you feel relaxed and confident throughout your visit. We understand that multiple cartilage piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to guide you, answer your questions, and provide reassurance. From consultation to completion, we focus on delivering a positive and stress-free experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for triple helix piercings, and we provide detailed instructions to help you maintain proper care during the healing process. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your triple helix piercing will heal effectively and remain a bold and stylish feature of your look.
          </p>

          <p>
            Our triple helix piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted triple helix piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a standout layered look effortlessly. Book your triple helix piercing appointment today and elevate your ear styling with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Triple Helix Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TripleHelixPiercing;